import { FC } from 'react';
import LazyComponentLoader from '../LazyComponentLoader';
import ILazyImageProperties from './types';

export default LazyComponentLoader({ loader: () => import('./LazyImage' /* webpackChunkName: "LazyImage" */) }) as FC<ILazyImageProperties>;
